import axios from 'axios'
import { ElMessage } from 'element-plus'

/**
 * 将完整 URL 或相对路径规范为 /uploads/xxx 形式。
 */
export function toUploadRelativePath(url) {
  if (!url) return ''
  const raw = String(url).trim()
  if (!raw) return ''
  try {
    const pathname = /^https?:\/\//i.test(raw)
      ? new URL(raw).pathname
      : raw.split('?')[0].split('#')[0]
    if (pathname.startsWith('/uploads/')) {
      return pathname
    }
    const idx = pathname.indexOf('/uploads/')
    if (idx >= 0) {
      return pathname.slice(idx)
    }
  } catch (e) {
    // ignore
  }
  return ''
}

function triggerBlobDownload(blob, filename) {
  const safeName = filename || '附件'
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = safeName
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(objectUrl)
}

async function parseBlobError(blob) {
  try {
    const text = await blob.text()
    const json = JSON.parse(text)
    return json.message || '下载失败'
  } catch (e) {
    return '下载失败'
  }
}

/**
 * 通过后端下载接口保存附件，文件名与上传时一致。
 */
export async function downloadAttachment(fileUrl, fileName) {
  const path = toUploadRelativePath(fileUrl)
  if (!path) {
    ElMessage.warning('无法下载该附件')
    return
  }
  const token = localStorage.getItem('token')
  const baseURL = process.env.VUE_APP_API_BASE || ''
  try {
    const response = await axios.get(`${baseURL}/api/files/download`, {
      params: {
        path,
        name: fileName || ''
      },
      responseType: 'blob',
      headers: token ? { Authorization: token } : {}
    })
    const blob = response.data
    const contentType = response.headers['content-type'] || ''
    if (contentType.includes('application/json')) {
      const message = await parseBlobError(blob)
      ElMessage.error(message)
      return
    }
    triggerBlobDownload(blob, fileName || path.split('/').pop() || '附件')
  } catch (error) {
    const res = error.response
    if (res?.data instanceof Blob) {
      const message = await parseBlobError(res.data)
      ElMessage.error(message)
      return
    }
    ElMessage.error(res?.data?.message || error.message || '下载失败')
  }
}
